import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';
import { AuthService } from 'src/app/services/auth.service';
declare var $ : any;
@Component({
  selector: 'app-meet-vibes-list',
  templateUrl: './meet-vibes-list.component.html',
  styleUrls: ['./meet-vibes-list.component.css']
})
export class MeetVibesListComponent implements OnInit {
  token: any;
  meetVibesList: any;
  p: any = 1;
  count: any = 0;
  total: any = 10;
  id: any;
  searchText: any = '';
  sideStatus: any;
  isChecked: any;
  foodPreferId: any = [];
  masterSelected: boolean = false;
  exportList: any;

  constructor(    public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private authService: AuthService,
    private activateroute: ActivatedRoute) { }

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  ngOnInit(): void {
    this.meetVibesListing();
  }

  meetVibesListing() {
    let offset = this.p - 1;
    if(this.searchText != '')
    {
      offset = 0;
    }
    let obj = {
      limit: 10,
      offset: offset,
      search: this.searchText,
    };
    this.token = localStorage['token'];
    this.prefrencesService.getMeetVibes(obj,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.meetVibesList =  res.data.data;
        this.count = res.data.total_count;
        console.log(this.meetVibesList);
      }
      else if (res.status == 400 && res.message == "Please provide valid token") {
        // this.toastr.error(res.message);
        this.router.navigate(['/login']);
      }
      else{
        // this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  
  checkSearchString() {
    if (!this.searchText) {
      // return this.stopSearchLoader();
    }
    this.meetVibesListing()
   }

   stopSearchLoader() {
    $('.lds-ring').css('display', 'none');
  }

  searchTextFilter() {
    this.meetVibesListing()
  }


  onTableDataChange(event: any) {
    this.p = event;
    this.masterSelected = false;
    this.foodPreferId = []
    this.meetVibesListing();
  }

  openModal(item: any){
    this.id = item.id;
  }

  deletePop(){
    let obj = {
      id: this.id,
    };
    console.log(obj)
    this.prefrencesService
      .deleteMeetVibes(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          $('#deletModal').modal('hide');
        } else if (res.status == 500) {
          this.toastr.success(res.message);
        }
        this.meetVibesListing();
      });
  }
}
